import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import CustomToaster from '@components/CustomToaster';
import { SubscribeFormProvider } from '@contexts/SubscribeFormContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { OfferOption, SelectedExtendedOffer } from '@utils/backend-api/subscribe';

import Checkout from './Checkout';
import OfferSelection from './OfferSelection';

const queryClient = new QueryClient();

enum Page {
  OfferSelection = 1,
  Checkout = 2,
}

interface HorizontalSubscribeProps {
  description?: string;
  dob: string;
  isUserCBPT?: boolean;
  offers: OfferOption[];
  stripeCustomerId?: string;
  userEmail?: string;
  userFullName?: string;
  userNextBillingDate?: string;
}

const HorizontalSubscribe = ({
  description,
  dob,
  isUserCBPT,
  offers,
  stripeCustomerId,
  userEmail,
  userFullName,
  userNextBillingDate,
}: HorizontalSubscribeProps) => {
  const [selectedOffer, setSelectedOffer] = useState<SelectedExtendedOffer>();
  const [currentPage, setCurrentPage] = useState(Page.OfferSelection);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <SubscribeFormProvider
      user={{
        dob,
        email: userEmail,
        isUserCBPT,
        name: userFullName,
        nextBillingDate: userNextBillingDate,
        stripeCustomerId,
      }}
    >
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <QueryClientProvider client={queryClient}>
          {currentPage === Page.OfferSelection && (
            <OfferSelection
              description={description}
              onOfferSelect={() => setCurrentPage(Page.Checkout)}
              offers={offers}
              selectedOffer={selectedOffer}
              setSelectedOffer={setSelectedOffer}
            />
          )}
          {currentPage === Page.Checkout && (
            <Checkout
              onBackClick={() => setCurrentPage(Page.OfferSelection)}
              selectedOffer={selectedOffer}
              presentedOfferCodes={offers.map((offer) => offer.code)}
            />
          )}
          <CustomToaster />
        </QueryClientProvider>
      </LocalizationProvider>
    </SubscribeFormProvider>
  );
};

export default HorizontalSubscribe;
